module.exports = __webpack_public_path__ + "static/img/banner.6d6ba60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/banner.png
// module id = mN5N
// module chunks = 23